import "./index.scss";

import ActionDownload from "assets/img/svg/actionDownload";
import Pdf from "assets/img/svg/pdf";
import ModalBox from "components/Modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { IDocument } from "store/documentStore";
import { deleteDocument } from "store/documentStore";

import StyledButton from "../StyledButton";

interface IActionDocumentModal {
    /**
     * Modal state
     */
    open: boolean;
    close: VoidFunction;
    /**
     * Document title
     */
    documentName: string | undefined;
    /**
     * Document data
     */
    document: IDocument | undefined;
    /**
     * Download document onClick() btn "download"
     */
    downloadDocument: () => void;
    /**
     * Delete the document
     */
    deleteDocument: () => void;
    /**
     * Render document informations : date / sent by
     */
    renderDocumentInfos: () => React.ReactNode;
    userEmail: string;
}

const ActionDocumentModal = ({
    open,
    close,
    documentName,
    document,
    downloadDocument,
    deleteDocument,
    renderDocumentInfos,
    userEmail,
}: IActionDocumentModal) => {
    const [t] = useTranslation();
    const [confirmAction, setConfirmAction] = useState(false);

    const renderMainTitle = (documentName: string | undefined) => (
        <div className="modal-title-element-wrapper">
            <Pdf />
            {documentName}
        </div>
    );
    const closeDocumentModal = () => {
        close();
        setConfirmAction(false);
    };
    const onDeleteDocument = () => {
        deleteDocument();
        close();
        setConfirmAction(false);
    };

    return (
        <ModalBox
            open={open}
            onClose={closeDocumentModal}
            subTitle={t("BPStatement.ChooseDocumentAction")}
            mainTitle={renderMainTitle(documentName)}
        >
            <div className="document-action-modal">
                {!confirmAction && (
                    <>
                        <div>{renderDocumentInfos()}</div>
                        <StyledButton buttonType="primary" fullWidth onClick={downloadDocument}>
                            <ActionDownload style={{ width: "16px", height: "16px" }} /> {t("ShowStatements.Download")}
                        </StyledButton>
                        {document?.uploadedBy == userEmail && (
                            <StyledButton buttonType="danger" fullWidth onClick={() => setConfirmAction(true)}>
                                {t("Beneficiars.Delete")}
                            </StyledButton>
                        )}
                    </>
                )}
                {confirmAction && (
                    <div className="document-action-confirm">
                        <span>{`${t("BPStatement.ConfirmDocumentDelete")}`}</span>
                        <span className="warning">{t("Titles.Alert")}.</span>
                        <div className="action-document-btns">
                            <StyledButton buttonType="danger" fullWidth onClick={onDeleteDocument}>
                                {t("Titles.Archive")}
                            </StyledButton>
                            <StyledButton buttonType="secondary" fullWidth onClick={closeDocumentModal}>
                                {t("Titles.NoCancel")}
                            </StyledButton>
                        </div>
                    </div>
                )}
            </div>
        </ModalBox>
    );
};

export default ActionDocumentModal;
